import { Asset } from '@thehubz/client/data-access-api';

export const DefaultAllStatusList = [
  {
    _id: Asset.StatusEnum.Uploaded,
    name: $localize`Uploaded`,
  },
  {
    _id: Asset.StatusEnum.Pending,
    name: $localize`Pending`,
  },
  {
    _id: Asset.StatusEnum.Approved,
    name: $localize`Approved`,
  },
  {
    _id: Asset.StatusEnum.Archived,
    name: $localize`Archived`,
  },
  {
    _id: Asset.StatusEnum.AwaitingApproval,
    name: $localize`Awaiting approval`,
  },
  {
    _id: Asset.StatusEnum.Draft,
    name: $localize`Draft`,
  },
  {
    _id: Asset.StatusEnum.Expired,
    name: $localize`Expired`,
  },
];
